import { useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../hooks/hooks";
import { selectSectionTemplatesListItems } from "../../../../../redux/section-templates/selector";
import { sectionTemplates } from "../../../../../redux/section-templates/action";
import PageLoader from "../../../../../components/PageLoader";
import Table from "../../../../../common/components/table-manager/v1.1/table";
import { ListCriteria } from "../../../types/list-criteria";

const ManagemenSectionTemplates = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const skipNextEffect = useRef(false); // flag to prevent double call
  const itemsData = useSelector(selectSectionTemplatesListItems)
  const [columnDefs, setColumnDefs] = useState({});
  const [searchCriteriaList, setSearchCriteriaList] = useState<any>([]);
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'Name', headerName: 'Name', searchField: 'Name', sortable: true, filter: true, filterType: 'text' },
      { field: 'StartDateUtc', headerName: 'Start Date', isDateValueFormat: true, },
      { field: 'EndDateUtc', headerName: 'End Date', isDateValueFormat: true, },
      { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true },
      { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat: true }
    ]);
  }

  const handleAdd = () => {
    navigate(`${0}`)
  }

  const handleEdit = (data: any) => {
    navigate(`${data?.Id}`)
  }

  const handleDelete = async (data: any) => {
    await dispatch(sectionTemplates.resetAction({ actionType: 'delete' }))
    await dispatch(sectionTemplates.delete({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/cms/template-groups/delete`,
      entity: 'sectionTemplates',
      jsonData: {
        Context: {},
        Records: [
          {
            Id: data?.Id,

          }
        ]
      }
    })).then(() => {
      handleReloadData();
    });
  }

  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
          <title>Add Discount</title>
          <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
        </svg>,
      callback: () => handleAdd(),
    },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handleReloadData(),
    }
  ];

  const fetchDiscountPolicyList = async ({
    pageNumber,
    pageSize,
  }, {
    searchCriteria,
    filterCriteria,
    dateCriteria
  }: ListCriteria) => {
    dispatch(sectionTemplates.list({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/cms/template-groups/list`,
      entity: 'sectionTemplates',
      jsonData: {
        Context: {},
        Records: [{}],
        Pagination: {
          "PageNumber": pageNumber,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
          "Searches": searchCriteria,
          "Filters": filterCriteria,
          "DateCriteria": dateCriteria
        }
      }
    }))
  }

  const handleReloadData = async () => {
    skipNextEffect.current = true;

    setPageData(1);
    setPageSize(10);

    await fetchDiscountPolicyList({ pageNumber: 1, pageSize: 10 }, {})
  }

  const handleSearch = (data: any) => {
    let searchCriteria = [];
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Name",
        FieldText: "Name",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    fetchDiscountPolicyList({ pageNumber: pageData, pageSize: pageSize }, {
      searchCriteria: searchCriteria
    });
  }

  useEffect(() => {
    createColumnDefs()
  }, [])

  useEffect(() => {
    if (skipNextEffect.current) {
      skipNextEffect.current = false;
      return;
    }

    fetchDiscountPolicyList({ pageNumber: pageData, pageSize: pageSize }, { searchCriteria: searchCriteriaList });
  }, [pageData, pageSize]);

  const handleSelect = (data: any) => {
  }

  return (
    <>
      {itemsData?.isLoading ? <PageLoader /> :
        <Table
          columnData={columnDefs}
          rowData={itemsData?.result?.items}
          setPageData={setPageData}
          setPageSize={setPageSize}
          enableFilter={true}
          onSearch={handleSearch}
          onSelect={handleSelect}
          paginationData={itemsData?.result?.pagination}
          onEdit={handleEdit}
          onDelete={handleDelete}
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'Name',
          }}

          additionButtons={additionButtons}
          headingName="Templates Groups"
        />
      }
    </>
  );
};

export default ManagemenSectionTemplates;


